<template>
  <!-- Original:
   <el-dialog
    v-model="visible"
    width="640px"
    :close-on-click-modal="true"
    class="active-alerts-modal"
  > -->
  <Dialog
    v-model="visible"
    dialog-type="secondary"
    dialog-size="small"
    title-variant="medium"
    headerBackgroundColor="var(--Cool-White, #F9FBFD)"
    footerBackgroundColor="var(--Cool-White, #F9FBFD)"
  >
    <template #header>
      <div class="active-alerts-modal__header">
        <svg style = "cursor:pointer" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M10.01 20.76C10.01 21.86 10.9 22.75 12 22.75C13.1 22.75 13.99 21.86 13.99 20.76H10.01ZM12 5.75C14.76 5.75 17 7.99 17 10.75V17.75H7V10.75C7 7.99 9.24 5.75 12 5.75ZM12 1.25C11.17 1.25 10.5 1.92 10.5 2.75V3.92C7.36 4.6 5 7.4 5 10.75V16.75L3 18.75V19.75H21V18.75L19 16.75V10.75C19 7.4 16.64 4.6 13.5 3.92V2.75C13.5 1.92 12.83 1.25 12 1.25ZM11 7.75H13V11.75H11V7.75ZM11 13.75H13V15.75H11V13.75Z" fill="#374957"/>
        </svg>
        <span>Active Alerts</span>
      </div>
      <svg @click="visible = false" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M22.1666 7.47833L20.5216 5.83333L13.9999 12.355L7.47825 5.83333L5.83325 7.47833L12.3549 14L5.83325 20.5217L7.47825 22.1667L13.9999 15.645L20.5216 22.1667L22.1666 20.5217L15.6449 14L22.1666 7.47833Z" fill="#374957"/>
        <mask id="mask0_910_33057" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="5" y="5" width="18" height="18">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M22.1666 7.47833L20.5216 5.83333L13.9999 12.355L7.47825 5.83333L5.83325 7.47833L12.3549 14L5.83325 20.5217L7.47825 22.1667L13.9999 15.645L20.5216 22.1667L22.1666 20.5217L15.6449 14L22.1666 7.47833Z" fill="white"/>
        </mask>
        <g mask="url(#mask0_910_33057)">
        </g>
      </svg>
    </template>
    <div class="active-alerts-modal__body" style = "padding: 0 16px 16px 16px; background-color: var(--Cool-White, #F9FBFD);">
      <div class="alerts-list">
        <div v-if="isLoading" class="alerts-loading">
          <svg class="loading-spinner" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="#E8ECF0" stroke-width="2"/>
            <path d="M12 2a10 10 0 0 1 10 10" stroke="#1E4670" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <p>Loading alerts...</p>
        </div>
        <div v-else-if="!alerts.length" class="alerts-empty">No active alerts.</div>
        <transition-group
          v-else
          name="resolve-slide"
          tag="div"
          @after-leave="handleAfterLeave"
        >
          <div
            v-for="alert in visibleAlerts"
            :key="alert.id"
            class="alert-item"
          >
          <div class="alert-icon" :class="alert.alert_type">
            <svg v-if="alert.alert_type === 'frustration_escalation'" xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
              <path d="M13.3333 26.6667C11.4889 26.6667 9.75556 26.3167 8.13333 25.6167C6.51111 24.9167 5.1 23.9667 3.9 22.7667C2.7 21.5667 1.75 20.1556 1.05 18.5333C0.35 16.9111 0 15.1778 0 13.3333C0 11.4889 0.35 9.75556 1.05 8.13333C1.75 6.51111 2.7 5.1 3.9 3.9C5.1 2.7 6.51111 1.75 8.13333 1.05C9.75556 0.35 11.4889 0 13.3333 0C15.1778 0 16.9111 0.35 18.5333 1.05C20.1556 1.75 21.5667 2.7 22.7667 3.9C23.9667 5.1 24.9167 6.51111 25.6167 8.13333C26.3167 9.75556 26.6667 11.4889 26.6667 13.3333C26.6667 15.1778 26.3167 16.9111 25.6167 18.5333C24.9167 20.1556 23.9667 21.5667 22.7667 22.7667C21.5667 23.9667 20.1556 24.9167 18.5333 25.6167C16.9111 26.3167 15.1778 26.6667 13.3333 26.6667ZM13.3333 24C16.2889 24 18.8056 22.9611 20.8833 20.8833C22.9611 18.8056 24 16.2889 24 13.3333C24 10.3778 22.9611 7.86111 20.8833 5.78333C18.8056 3.70556 16.2889 2.66667 13.3333 2.66667C10.3778 2.66667 7.86111 3.70556 5.78333 5.78333C3.70556 7.86111 2.66667 10.3778 2.66667 13.3333C2.66667 16.2889 3.70556 18.8056 5.78333 20.8833C7.86111 22.9611 10.3778 24 13.3333 24ZM15.3333 11.8667L16 11.4667C16.0444 12 16.2556 12.4444 16.6333 12.8C17.0111 13.1556 17.4667 13.3333 18 13.3333C18.5556 13.3333 19.0278 13.1389 19.4167 12.75C19.8056 12.3611 20 11.8889 20 11.3333C20 11 19.9222 10.6833 19.7667 10.3833C19.6111 10.0833 19.4 9.84444 19.1333 9.66667L20 9.16667L19.3333 8L14.6667 10.6667L15.3333 11.8667ZM11.3333 11.8667L12 10.6667L7.33333 8L6.66667 9.16667L7.53333 9.66667C7.26667 9.84444 7.05556 10.0833 6.9 10.3833C6.74444 10.6833 6.66667 11 6.66667 11.3333C6.66667 11.8889 6.86111 12.3611 7.25 12.75C7.63889 13.1389 8.11111 13.3333 8.66667 13.3333C9.2 13.3333 9.65555 13.1556 10.0333 12.8C10.4111 12.4444 10.6222 12 10.6667 11.4667L11.3333 11.8667ZM13.3333 14.6667C11.7556 14.6667 10.3667 15.1722 9.16667 16.1833C7.96667 17.1944 7.12222 18.4667 6.63333 20H20.0333C19.5444 18.4667 18.7 17.1944 17.5 16.1833C16.3 15.1722 14.9111 14.6667 13.3333 14.6667Z" fill="#D10000"/>
            </svg>
            <svg v-else-if = "alert.alert_type === 'negative_sentiment'"xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
              <path d="M20.6667 14.6667C21.7713 14.6667 22.6667 13.7712 22.6667 12.6667C22.6667 11.5621 21.7713 10.6667 20.6667 10.6667C19.5622 10.6667 18.6667 11.5621 18.6667 12.6667C18.6667 13.7712 19.5622 14.6667 20.6667 14.6667Z" fill="#FEB52E"/>
              <path d="M11.3334 14.6667C12.438 14.6667 13.3334 13.7712 13.3334 12.6667C13.3334 11.5621 12.438 10.6667 11.3334 10.6667C10.2288 10.6667 9.33341 11.5621 9.33341 12.6667C9.33341 13.7712 10.2288 14.6667 11.3334 14.6667Z" fill="#FEB52E"/>
              <path d="M16.0001 18.6667C12.8934 18.6667 10.2401 20.6 9.17341 23.3333H11.4001C12.3201 21.7467 14.0267 20.6667 16.0001 20.6667C17.9734 20.6667 19.6667 21.7467 20.6001 23.3333H22.8267C21.7601 20.6 19.1067 18.6667 16.0001 18.6667ZM15.9867 2.66666C8.62675 2.66666 2.66675 8.64 2.66675 16C2.66675 23.36 8.62675 29.3333 15.9867 29.3333C23.3601 29.3333 29.3334 23.36 29.3334 16C29.3334 8.64 23.3601 2.66666 15.9867 2.66666ZM16.0001 26.6667C10.1067 26.6667 5.33341 21.8933 5.33341 16C5.33341 10.1067 10.1067 5.33333 16.0001 5.33333C21.8934 5.33333 26.6667 10.1067 26.6667 16C26.6667 21.8933 21.8934 26.6667 16.0001 26.6667Z" fill="#FEB52E"/>
            </svg>  
            <svg v-else-if= "alert.alert_type === 'unanswered_48h'"  xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
              <path d="M16.0001 2.66667C8.64008 2.66667 2.66675 8.64 2.66675 16C2.66675 23.36 8.64008 29.3333 16.0001 29.3333C23.3601 29.3333 29.3334 23.36 29.3334 16C29.3334 8.64 23.3601 2.66667 16.0001 2.66667ZM16.0001 26.6667C10.1067 26.6667 5.33341 21.8933 5.33341 16C5.33341 10.1067 10.1067 5.33334 16.0001 5.33334C21.8934 5.33334 26.6667 10.1067 26.6667 16C26.6667 21.8933 21.8934 26.6667 16.0001 26.6667Z" fill="#004879"/>
              <path d="M9.33341 18C10.438 18 11.3334 17.1046 11.3334 16C11.3334 14.8954 10.438 14 9.33341 14C8.22884 14 7.33341 14.8954 7.33341 16C7.33341 17.1046 8.22884 18 9.33341 18Z" fill="#004879"/>
              <path d="M16.0001 18C17.1046 18 18.0001 17.1046 18.0001 16C18.0001 14.8954 17.1046 14 16.0001 14C14.8955 14 14.0001 14.8954 14.0001 16C14.0001 17.1046 14.8955 18 16.0001 18Z" fill="#004879"/>
              <path d="M22.6667 18C23.7713 18 24.6667 17.1046 24.6667 16C24.6667 14.8954 23.7713 14 22.6667 14C21.5622 14 20.6667 14.8954 20.6667 16C20.6667 17.1046 21.5622 18 22.6667 18Z" fill="#004879"/>
            </svg>
          </div>
          <div class="alert-content">
            <span class="patient-name">{{ formatPatientName(alert.patient_info) }}</span>
            <span class="alert-detail">{{ formatAlertType(alert.alert_type) }}{{ alert.details?.hours_unanswered ? ` • ${alert.details.hours_unanswered}h ago` : '' }}</span>
          </div>
          <div class="alert-actions">
            <ResponsiveButton 
              display_name="Resolve" 
              button_type = "text"
              @click-button="resolveAlert(alert.id)"
            >
              <template #prefix>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <g clip-path="url(#clip0_2317_3575)">
                      <path d="M10.0001 18.3333C14.6025 18.3333 18.3334 14.6024 18.3334 10C18.3334 5.39763 14.6025 1.66667 10.0001 1.66667C5.39771 1.66667 1.66675 5.39763 1.66675 10C1.66675 14.6024 5.39771 18.3333 10.0001 18.3333Z" stroke="#374957" stroke-width="1.5"/>
                      <path d="M7.0835 10.4167L8.75016 12.0833L12.9168 7.91667" stroke="#374957" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_2317_3575">
                        <rect width="20" height="20" fill="white"/>
                      </clipPath>
                    </defs>
                  </svg>
              </template>
            </ResponsiveButton>
            <!-- <TextButton @click="resolveAlert(alert.id)">
              <template #prefix>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <g clip-path="url(#clip0_2317_3575)">
                    <path d="M10.0001 18.3333C14.6025 18.3333 18.3334 14.6024 18.3334 10C18.3334 5.39763 14.6025 1.66667 10.0001 1.66667C5.39771 1.66667 1.66675 5.39763 1.66675 10C1.66675 14.6024 5.39771 18.3333 10.0001 18.3333Z" stroke="#374957" stroke-width="1.5"/>
                    <path d="M7.0835 10.4167L8.75016 12.0833L12.9168 7.91667" stroke="#374957" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_2317_3575">
                      <rect width="20" height="20" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>
              </template>
              Resolve
            </TextButton> -->
            <ResponsiveButton 
              display_name="Chat" 
              button_border_radius="100px"
              button_type = "outlined"
              @click-button="goToChatRoom(alert.room_id)"
            >
              <template #prefix>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M15 4V11H5.17L4 12.17V4H15ZM16 2H3C2.45 2 2 2.45 2 3V17L6 13H16C16.55 13 17 12.55 17 12V3C17 2.45 16.55 2 16 2ZM21 6H19V15H6V17C6 17.55 6.45 18 7 18H18L22 22V7C22 6.45 21.55 6 21 6Z" fill="#374957"/>
                </svg>
              </template>
            </ResponsiveButton>
            <!-- <Button
              style="border-radius: 15px;"
              type="small"
              color-type="dark-blue-stroke"
              @click="goToChatRoom(alert.room_id)"
            > 
              <div style="display: flex; align-items: center; gap: 4px;">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M15 4V11H5.17L4 12.17V4H15ZM16 2H3C2.45 2 2 2.45 2 3V17L6 13H16C16.55 13 17 12.55 17 12V3C17 2.45 16.55 2 16 2ZM21 6H19V15H6V17C6 17.55 6.45 18 7 18H18L22 22V7C22 6.45 21.55 6 21 6Z" fill="#374957"/>
                </svg>
                <span>Chat</span>
              </div>
            </Button> -->
          </div>
        </div>
      </transition-group>
    </div>
    </div>
    
    <template #footer>
      <div style="display: flex; justify-content: center; width: 100%;">
        <ResponsiveButton 
          size = "medium"
          display_name="Cancel" 
          button_type = "outlined"
          built_in_theme = "error"
          @click-button="visible = false" />
      </div>
      
      <!-- <Button
        color-type="red-stroke"
        @click="visible = false"
      >
        Cancel
      </Button> -->
    </template>
  </Dialog>
  <!-- Original:
   </el-dialog> -->
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import Button from '@/NewLibrary/Button.vue';
import TextButton from '@/views/commonComponents/TextButton.vue';

const props = defineProps({
  modelValue: { type: Boolean, default: false },
});
const emit = defineEmits(['update:modelValue']);

const store = useStore();
const searchQuery = ref('');
const visible = ref(props.modelValue);
const resolvingAlertIds = ref(new Set());

// Fetch alerts when modal opens
watch(() => props.modelValue, (isOpen) => {
  visible.value = isOpen;
  if (isOpen) {
    store.dispatch('myPractice/clinicDashboard/fetchActiveAlertsData');
  }
});
watch(visible, (isOpen) => {
  emit('update:modelValue', isOpen);
});

const isLoading = computed(() => store.state.myPractice.clinicDashboard.activeAlertsLoading);

const alerts = computed(() => {
  const data = store.state.myPractice.clinicDashboard.activeAlertsData || [];
  if (!searchQuery.value) return data;
  const q = searchQuery.value.toLowerCase();
  return data.filter((a) =>
    a.alert_type?.toLowerCase().includes(q) ||
    a.patient_id?.toLowerCase().includes(q)
  );
});

const visibleAlerts = computed(() => {
  return alerts.value.filter(alert => !resolvingAlertIds.value.has(alert.id));
});

function formatPatientName(patientInfo) {
  if (!patientInfo) return 'Unknown Patient';
  return `${patientInfo.first_name || ''} ${patientInfo.last_name || ''}`.trim() || 'Unknown Patient';
}

function formatAlertType(type) {
  switch (type) {
    case 'negative_sentiment':
      return 'Negative sentiment detected';
    case 'frustration_escalation':
      return 'Frustration escalation detected';
    case 'unanswered_48h':
      return 'Unanswered message';
    default:
      return 'Alert';
  }
}

async function resolveAlert(alertId) {
  resolvingAlertIds.value.add(alertId);
}

async function handleAfterLeave() {
  const alertsToResolve = Array.from(resolvingAlertIds.value);
  resolvingAlertIds.value.clear();
  
  for (const alertId of alertsToResolve) {
    try {
      await store.dispatch('myPractice/clinicDashboard/resolveActiveAlert', alertId);
    } catch (error) {
      console.error('Failed to resolve alert:', error);
    }
  }
}

const router = useRouter();

async function goToChatRoom(roomId) {
  // TODO: Implement chat opening logic
  if(roomId) {
    router.push(`/my-patients?roomId=${roomId}`);
  }else{
    router.push('/my-patients');
  }
}
</script>

<style scoped>
.active-alerts-modal__header {
  display: flex;
  align-items: center;
  gap: 4px;
}
.active-alerts-modal__header span {
  color: var(--IconGrey, #374957);
  font-family: 'Inter', sans-serif;
  font-size: 20px;
  font-weight: 600;
}
.alerts-filters {
  margin-bottom: 16px;
}

.alerts-search {
  width: 100%;
}

.alerts-list {
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 400px;
  overflow-y: auto;
  padding: 8px 12px;
  background: var(--White, #FFF);
}

.alerts-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 0;
  gap: 16px;
}

.loading-spinner {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.alerts-loading p {
  color: #6B7280;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
}

.alerts-empty {
  text-align: center;
  color: #9CA3AF;
  padding: 32px 0;
  font-size: 14px;
}
.alerts-list > :last-child {
  border-bottom: none;
} 
.alert-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border-bottom: 1px solid #C4C4C4;
}

.alert-icon {
  width: 40px;
  height: 40px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.alert-icon.negative_sentiment {
  background: #FEF9E9;
  color: #FEB52E;
}

.alert-icon.frustration_escalation {
  background: #FAEAEA;
  color: #D10000;
}
.alert-icon.unanswered_48h {
  background: #E8F4FD;
  color: #004879;
}

.alert-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
}

.patient-name {
  color: #333;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
}

.alert-detail {
  color:#666;

  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.4px;
}

.alert-actions {
  flex-shrink: 0;
  display: flex;
  gap: 4px;
}

.resolve-slide-leave-active {
  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1), 
              opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.resolve-slide-leave-to {
  transform: translateX(-100%) scale(0.95);
  opacity: 0;
}

.resolve-slide-move {
  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}
</style>

<style>
.active-alerts-modal {
  padding: 0px 24px;
  background: #F9FBFD;
}
.active-alerts-modal .el-dialog__header {
  padding: 16px 0px !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.active-alerts-modal .el-dialog__headerbtn {
  display: none !important;
}
.active-alerts-modal .el-dialog__body {
  background: #fff;
  padding: 8px 12px !important;
}
.active-alerts-modal .el-dialog__footer {
  border-top: 1px dashed #C4C4C4;
  padding: 24px 0px !important;
  display: flex;
  justify-content: center;
  margin-top: 16px;
}
</style>
